import cookieHandler from "AtomicUtils/cookieHandler"

/* Ducks is a modular redux model where you put a duck.js file
in the same folder of the react component that uses it.
More info: https://github.com/erikras/ducks-modular-redux
 */

// Action types
export const gtmEventTypes = {
  CONTACT_US_SELECT_TOPIC: "CONTACT_US_GITF_SELECT_TOPIC",
  CONTACT_US_SELECT_TITLE: "CONTACT_US_GITF_SELECT_TITLE",
  CONTACT_US_ENTER_FIRSTNAME: "CONTACT_US_GITF_ENTER_FIRSTNAME",
  CONTACT_US_ENTER_LASTNAME: "CONTACT_US_GITF_ENTER_LASTNAME",
  CONTACT_US_ENTER_PHONE: "CONTACT_US_GITF_ENTER_PHONE",
  CONTACT_US_ENTER_EMAIL: "CONTACT_US_GITF_ENTER_EMAIL",
  CONTACT_US_ENTER_ENQUIRY: "CONTACT_US_GITF_ENTER_ENQUIRY",
  CONTACT_US_ENTER_REGISTRATION_OR_VIN: "CONTACT_US_GITF_ENTER_REGISTRATION_OR_VIN",
  CONTACT_US_ENTER_ADDRESS: "CONTACT_US_GITF_ENTER_ADDRESS",
  CONTACT_US_SELECT_POSTCODE_SUBURB: "CONTACT_US_GITF_SELECT_POSTCODE_SUBURB",
  CONTACT_US_ENTER_OLD_VIN_REGO: "CONTACT_US_GITF_ENTER_OLD_VIN_REGO",
  CONTACT_US_ENTER_CURRENT_VIN_REGO: "CONTACT_US_GITF_ENTER_CURRENT_VIN_REGO",
  CONTACT_US_CHECK_PRIVACY_POLICY: "CONTACT_US_GITF_CHECK_PRIVACY_POLICY",
  CONTACT_US_CLICK_PRIVACY_POLICY: "CONTACT_US_GITF_CLICK_PRIVACY_POLICY",
  CONTACT_US_CLICK_GO_BACK: "CONTACT_US_GITF_CLICK_GO_BACK",
  CONTACT_US_CLICK_SUBMIT: "CONTACT_US_GITF_CLICK_SUBMIT"
}

// Action creators
export const gtmEvents = {
  [gtmEventTypes.CONTACT_US_SELECT_TOPIC]: ({ model = "" }) => ({
    type: gtmEventTypes.CONTACT_US_SELECT_TOPIC,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: "FED-GITF-001",
    pageCategory: "Get In Touch Form",
    pageAction: `Get In Touch Form - Selected "TOPIC" - "${model.toUpperCase()}"`
  }),
  [gtmEventTypes.CONTACT_US_SELECT_TITLE]: ({ model = "" }) => ({
    type: gtmEventTypes.CONTACT_US_SELECT_TITLE,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: "FED-GITF-002",
    pageCategory: "Get In Touch Form",
    pageAction: `Get In Touch Form - Selected "TITLE" - "${model.toUpperCase()}"`
  }),
  [gtmEventTypes.CONTACT_US_ENTER_FIRSTNAME]: () => ({
    type: gtmEventTypes.CONTACT_US_ENTER_FIRSTNAME,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: "FED-GITF-003",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Entered \"FIRSTNAME\""
  }),
  [gtmEventTypes.CONTACT_US_ENTER_LASTNAME]: () => ({
    type: gtmEventTypes.CONTACT_US_ENTER_LASTNAME,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: "FED-GITF-004",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Entered \"LASTNAME\""
  }),
  [gtmEventTypes.CONTACT_US_ENTER_PHONE]: () => ({
    type: gtmEventTypes.CONTACT_US_ENTER_PHONE,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: "FED-GITF-005",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Entered \"PHONE\""
  }),
  [gtmEventTypes.CONTACT_US_ENTER_EMAIL]: () => ({
    type: gtmEventTypes.CONTACT_US_ENTER_EMAIL,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: "FED-GITF-006",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Entered \"EMAIL\""
  }),
  [gtmEventTypes.CONTACT_US_ENTER_ENQUIRY]: () => ({
    type: gtmEventTypes.CONTACT_US_ENTER_ENQUIRY,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: "FED-GITF-007",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Entered \"ENQUIRY\""
  }),
  [gtmEventTypes.CONTACT_US_ENTER_REGISTRATION_OR_VIN]: () => ({
    type: gtmEventTypes.CONTACT_US_ENTER_REGISTRATION_OR_VIN,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: "FED-GITF-008",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Entered \"REGISTRATION OR VIN\""
  }),
  [gtmEventTypes.CONTACT_US_ENTER_ADDRESS]: () => ({
    type: gtmEventTypes.CONTACT_US_ENTER_ADDRESS,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: "FED-GITF-009",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Entered \"ADDRESS\""
  }),
  [gtmEventTypes.CONTACT_US_SELECT_POSTCODE_SUBURB]: ({ model = "" }) => ({
    type: gtmEventTypes.CONTACT_US_SELECT_POSTCODE_SUBURB,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: "FED-GITF-010",
    pageCategory: "Get In Touch Form",
    pageAction: `Get In Touch Form - Selected "POSTCODE/SUBURB" - "${model.toUpperCase()}"`
  }),
  [gtmEventTypes.CONTACT_US_ENTER_OLD_VIN_REGO]: () => ({
    type: gtmEventTypes.CONTACT_US_ENTER_OLD_VIN_REGO,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: "FED-GITF-011",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Entered \"OLDVINREGO\""
  }),
  [gtmEventTypes.CONTACT_US_ENTER_CURRENT_VIN_REGO]: () => ({
    type: gtmEventTypes.CONTACT_US_ENTER_CURRENT_VIN_REGO,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: "FED-GITF-012",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Entered \"CURRENTVINREGO\""
  }),
  [gtmEventTypes.CONTACT_US_CHECK_PRIVACY_POLICY]: () => ({
    type: gtmEventTypes.CONTACT_US_CHECK_PRIVACY_POLICY,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: "FED-GITF-013",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Checked \"PRIVACYPOLICY\""
  }),
  [gtmEventTypes.CONTACT_US_CLICK_PRIVACY_POLICY]: () => ({
    type: gtmEventTypes.CONTACT_US_CLICK_PRIVACY_POLICY,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: "FED-GITF-014",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Clicked \"PRIVACYPOLICY\""
  }),
  [gtmEventTypes.CONTACT_US_CLICK_SUBMIT]: ({ model = "" }) => ({
    type: gtmEventTypes.CONTACT_US_CLICK_SUBMIT,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: "FED-GITF-015",
    pageCategory: "Get In Touch Form",
    pageAction: `Get In Touch Form - Clicked "${model.toUpperCase()}"`
  }),
  [gtmEventTypes.CONTACT_US_CLICK_GO_BACK]: () => ({
    type: gtmEventTypes.CONTACT_US_CLICK_GO_BACK,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: "FED-GITF-016",
    pageCategory: "Get In Touch Form",
    pageAction: "Get In Touch Form - Clicked \"GO BACK\""
  })
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/contact-us-duck.js